import { ParkingLocation } from 'containers/pages/CANpark/types/parkingLocation';

export const toParkingLocationPayload = (location: ParkingLocation) => ({
	ParkingLocationId: location.id,
	CompanyId: location.customerID,
	Name: location.name,
	ViolationCheckType: location.violationCheckType,
	ViolationCheckWindowDays: location.violationCheckWindowDays,
	MaxStayMinutes: location.maxStayMinutes,
	TaggingPolicyType: location.taggingPolicyType,
	TaggingAfterViolations: location.taggingAfterViolations,
	TowPolicyType: location.towPolicyType,
	towAfterViolations: location.towAfterViolations,
	ShowScanPreview: location.showScanPreview,
	ShowActionStage: location.showActionStage,
	ShowCarPhotoStage: location.showCarPhotoStage,
	ShowConfirmStage: location.showConfirmStage,
	EnableOverstayNotifications: location.enableOverstayNotifications,
	TowingCompanyNumber: location.towingCompanyNumber ?? '',
	TowingCompanyName: location.towingCompanyName ?? '',
	TowInstructions: location.towInstructions ?? '',
	ZoneOptions: location.parkingZoneOptions.map((z) => ({
		Id: z.id,
		Name: z.name,
	})),
});
